import GenericHttpService from './GenericHttpService';
import http from 'utils/HttpCommon';

const emptyObject = {
  idSiconfiDivida: '',
  garantidor: null,
  dataContratacao: null,
  valorContrato: "0",
  moeda:null  
};

const endpoint = 'garantia';

const create = (data) => {
  data = converterGarantidor(data);
  return http.post(`/${endpoint}/criar`, data);
}

const update = (id, data) => {
  data = converterGarantidor(data);
  return http.put(`/${endpoint}/atualizar/${id}`, data);
}

const converterGarantidor = (data) => {

  if (data?.garantidor?.info) {
    const { info } = data.garantidor;
    data.garantidor = {
      identificador: info.cnpj,
      nome: info.nome,
      codIbge: info.codIbge,
      siglaUF: info.siglaUF,
      tipoEnte: info.tipoEnte
    };
  }
  return data;
};

export default {
  ...GenericHttpService(endpoint), getEmptyObject: () => ({...emptyObject}),
  create,
  update,
};